<template>
	<vs-col vs-w="9">

    <h1>No results to display</h1>

    <span v-if="loading">
      Waiting for results.. Consider adding an animated cruise ship here
    </span>
    <span v-else>
      Please build up your query and click search
    </span>

  </vs-col>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
